import reducer from "./reducers";
export default reducer;